import { getQueryParam } from "../configs/configLoader";

interface PrivacyPolicyConfig {
  urls: {
    default: string;
    [market: string]: string | Record<string, string>;
  };
}

export function resolvePrivacyPolicyUrl(
  config: PrivacyPolicyConfig | undefined,
): string | undefined {
  if (!config?.urls) return undefined;

  const market = (
    getQueryParam("countryCode") || getQueryParam("market") || ""
  ).toUpperCase();
  const lang = getQueryParam("lang") || "";

  const marketUrls = config.urls[market];

  // Market exists in config
  if (marketUrls && typeof marketUrls === "object") {
    // Market + lang match
    if (lang && marketUrls[lang]) return marketUrls[lang];
    // Lang not found → market default
    return marketUrls.default;
  }

  // Market not found → general default
  return config.urls.default;
}
